import React, {  useEffect, useRef, useState } from 'react';
import TicTacToe from '../components/TicTacToe';
import ScriptLink from '../components/ScriptLink';
import { motion } from 'framer-motion';
import {IconSwipeDown} from '@tabler/icons-react';
import ContactForm from '../components/ContactForm';
import BentoGrid from '../components/BentoGrid';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';


const HomePage = (props) => {
    const [backgroundPosition, setBackgroundPosition] = useState({ x: -230, y: -100 });
    const data = useSelector((state) => state.data.data);
    const bentoRef = useRef(null);
    const contactRef = useRef(null);
    const location = useLocation();

    const scrollToRef = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        if (location.hash === '#contact') {
            scrollToRef(contactRef);
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [location]);

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = (e.clientX - left - width / 2) / 2; // Adjust sensitivity as needed
        const y = (e.clientY - top - height / 2) / 2; // Adjust sensitivity as needed
        setBackgroundPosition({ x, y });
    };
  
    const handleMouseLeave = () => {
        setBackgroundPosition({ x: -230, y: -100 });
    };


    return(
        <div className='ml-auto mr-auto pl-5 overflow-hidden pr-5 max-w-5xl'>
            {/* ----- Hero ------ */}
            <div className="min-h-screen lg:mt-28 flex lg:min-h-96 sm:min-h-fit sm:flex-col">
                <div
                    className="flex-1 flex flex-col justify-center p-2 relative rounded-lg"
                    style={{
                        background: 'radial-gradient(circle, rgba(167,139,250,0.175) 0%, rgba(255,255,255,0) 40%)',
                        backgroundSize: '90% 90%',
                        backgroundPosition: `${20 + backgroundPosition.x}% ${20 + backgroundPosition.y}%`,
                        transition: 'background-position 0.3s ease-out',
                        backgroundRepeat: 'no-repeat'
                    }}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                >
                    <motion.div
                        className='text-gray-300'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1 }}
                    >
                        Hello all! I am
                    </motion.div>
                    <motion.div
                        className='font-medium text-6xl mt-2 md:text-5xl'
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                    >
                        {data.meta.name}
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, delay: 0.75 }}
                    >
                        <div className='font-medium text-3xl text-purple-600 transition cursor-pointer hover:text-purple-500 hover:translate-x-3 mt-5 md:text-2xl sm:hover:translate-x-0'>
                            {`>. ${data.meta.role}`}
                        </div>
                    </motion.div>
                    <motion.div
                        className='text-gray-500 sm:text-sm mt-6'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1.5, delay: 1 }}
                    >
                        {`// I create apps that inspires`}
                    </motion.div>
                    <motion.div
                        className='text-gray-500 sm:text-sm mb-3'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1.25, delay: 1.25 }}
                    >
                        {`// Scroll down to explore my world`}
                    </motion.div>
                    <motion.div
                        className='text-gray-500 sm:text-sm mb-3'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1.5, delay: 1.5 }}
                    >
                        <ScriptLink link={data.meta.social.github} title="githubLink" />
                    </motion.div>
                    <motion.div
                        className='flex sm:flex-col mt-6'
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, delay: 0.75 }}
                    >
                        <Link target='_blank' to={data.meta.resume}><div className="btn sm:w-fit sm:mr-0 sm:mb-4 mr-4"><span>{`>.  `}</span>Download CV.</div></Link>
                        <Link to="/#contact"><div className="btn sm:w-fit alt-btn"><span>{`>.  `}</span>Contact Me.</div></Link>
                    </motion.div>
                </div>
                <motion.div
                    style={{flex: 0.6}} className="flex flex-col justify-center items-center md:mt-36 sm:mt-28"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.75 }}
                >
                    <TicTacToe />
                </motion.div>

            </div>
            <motion.div
                style={{flex: 0.6}} className="absolute swiper bottom-7 lg:hidden cursor-pointer"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.75 }}
                onClick={() => {scrollToRef(bentoRef)}}
            >
                <IconSwipeDown size={36} className='text-gray-600' stroke={1.5} />
            </motion.div>


            <div ref={bentoRef}>
            <BentoGrid />
            </div>

            <div ref={contactRef}>
                <ContactForm />
            </div>
        </div>
    );
}

export default HomePage;
